import HeaderTop from './HeaderTop';
import HeaderMain from './HeaderMain';
import ConfigUtil from '../util/ConfigUtil';

const HeaderContainer = () => {
    const webType = ConfigUtil.getWebType().toLowerCase();
    return (
        <header className='header'>
            <HeaderTop webType={webType} />
            <HeaderMain webType={webType} />
        </header>
    );
};

export default HeaderContainer;
